// ============================================
// NUEVOS ESTILOS - Old Fashion
// ============================================
import './css/main.scss';

// ============================================
// IMPORTS FUNCIONALES DINÁMICOS
// ============================================
import * as VISTAS from './js/vistas.js';
import { obtenerUrlBackend } from './js/utilerias.js';


import { 
  paginaestiloCtesTab, 
  generarGraficaSeleccionada, 
  configurarModalColores 
} from './js/estiloCtesTab.js';
import { 
  paginaclientePartsTab, 
  generarGraficaCtes, 
  configurarModalEstilos 
} from './js/clientePartsTab.js';
import { 
  paginaarticuloCtesTab, 
  configurarModalKpisEst 
} from './js/articuloCtesTab.js';

// ============================================
// AUTENTICACIÓN INICIAL
// ============================================
if (localStorage.getItem('isAuthenticated') !== 'true') {
  window.location.replace('login.html');
}

// ============================================
// REFERENCIAS DOM
// ============================================
const app = document.getElementById('app');
const sidebar = document.getElementById('sidebar');
const btnHideSidebar = document.getElementById('btn-hide-sidebar');
const btnShowSidebar = document.getElementById('btn-show-sidebar');
const headerTitle = document.getElementById('header-title');
const content = document.querySelector('.content');
const sidebarOverlay = document.getElementById('sidebar-overlay');
const btnLogout = document.getElementById('btn-logout');

// Único contenedor del menú principal (Barra lateral)
const menuAplicaciones = document.getElementById('menu-aplicaciones');
const URL_BASE_API = obtenerUrlBackend('8083');

// ============================================
// REFERENCIAS DOM - HEADER
// ============================================
const btnHeaderMore =
    document.getElementById('btn-header-more');

const headerMoreMenu =
    document.getElementById('header-more-menu');

const btnHeaderSeleccionar =
    document.getElementById('btn-header-seleccionar');

const btnHeaderExportar =
    document.getElementById('btn-header-exportar');

const btnHeaderMostrar =
    document.getElementById('btn-header-mostrar');

// ============================================
// REFERENCIAS DOM - HOME
// ============================================
const btnHome =
    document.getElementById('btn-header-home');

// ============================================
// REFERENCIAS DOM - FAVORITOS
// ============================================
const btnHeaderFavorite =
  document.getElementById('btn-header-favorite');

const menuFavoritos =
  document.getElementById('menu-favoritos');

// ============================================
// REFERENCIAS DOM - CONTENEDOR DE BIENVENIDA hasta la linea 743
// ============================================
let casaContainer =
    document.getElementById('casa-container');

// ============================================
// VARIABLES GLOBALES
// ============================================
let menuUsuario = [];

// Diagnóstico de sesión
const isAuth = localStorage.getItem('isAuthenticated');
const token = sessionStorage.getItem('token_teresita');

console.log('🔍 DIAGNÓSTICO DE CONTROL INTERNO:');
console.log('   isAuthenticated:', isAuth);
console.log('   token:', token);

if (isAuth !== 'true') {
  window.location.replace('login.html');
}


// VARIABLES GLOBALES - FAVORITOS
let opcionActiva = null;
let favoritosUsuario = [];

// ============================================
// FUNCIONES DE ACCESO Y RENDERIZADO
// ============================================

async function cargarMenuUsuario() {
  const token = sessionStorage.getItem('token_teresita');
  
  try {
    
    const response = await fetch(`${URL_BASE_API}/api/acceso/menu`, {
      headers: {'Authorization': token }
    });
    
    if (!response.ok) throw new Error('Error al cargar menú corporativo');

    const data = await response.json();
    menuUsuario = data.menu; 
    renderizarMenu(menuUsuario);
    
  } catch (error) {
    console.error('Error crítico al cargar menú dinámico:', error);
    window.location.replace('login.html');
  }
}

// ============================================
// FUNCIONES DE RENDERIZADO DEL MENÚ DINÁMICO
// ============================================
function renderizarMenu(menu) {
  if (menuAplicaciones) menuAplicaciones.innerHTML = '';

  if (!menu || menu.length === 0) {
    console.warn("⚠️ Advertencia: La API no retornó módulos configurados para este usuario.");
    return;
  }

  // Mapear dinámicamente cada bloque padre y sus respectivos submenús hilos
  const htmlMenuCompleto = menu.map(grupo => {
    if (!grupo.opciones || grupo.opciones.length === 0) return '';

    return `
      <li class="sidebar__item sidebar__item--parent" data-title="${grupo.menu_padre}">
        <a href="javascript:void(0)">
          <i class="fas ${grupo.icono_padre}"></i>
          <span>${grupo.menu_padre}</span>
          <i class="fas fa-chevron-down sidebar__arrow"></i>
        </a>
        <ul class="sidebar__submenu">
          ${grupo.opciones.map(sub => `
            <li class="sidebar__item" data-title="${sub.nombre}">
              <a href="${sub.ruta || '#'}" data-codigo="${sub.codigo}">
                <i class="fas ${sub.icono}"></i>
                <span>${sub.nombre}</span>
              </a>
            </li>
          `).join('')}
        </ul>
      </li>
    `;
  }).join('');

  if (menuAplicaciones) {
    menuAplicaciones.innerHTML = htmlMenuCompleto;
  }
  
  
  configurarEventosMenu();
  configurarEventosSidebar();
}

function tieneAcceso(codigo) {
  
  return menuUsuario.some(grupo => 
    grupo.opciones && grupo.opciones.some(sub => sub.codigo === codigo)
  );
}

function configurarEventosMenu() {
  if (menuAplicaciones) {
    
    menuAplicaciones.removeEventListener('click', manejarClickMenu);
    menuAplicaciones.addEventListener('click', manejarClickMenu);
  }
}

function manejarClickMenu(e) {
    
    const parentLink = e.target.closest('.sidebar__item--parent > a');
    if (parentLink) {
        e.preventDefault();
        e.stopPropagation(); 
        const parentItem = parentLink.closest('.sidebar__item--parent');
        toggleSubmenu(parentItem);
        return;
    }
    
    
    const link = e.target.closest('a[data-codigo]');
    if (!link) return;
    
    e.preventDefault();
    const codigo = link.getAttribute('data-codigo');
    
    if (!tieneAcceso(codigo)) {
        console.warn(`🛑 Acceso Denegado por Política del Sistema a: ${codigo}`);
        return;
    }
    
    if (window.innerWidth <= 768) {
        closeMobileSidebar();
    }
    
    const item = link.closest('.sidebar__item');
    setActiveItem(item);
    
    if (!content) return;
    
    // =========================================================================
    // INVOCACIÓN DINÁMICA DE VISTAS (Catálogo sin Hardcode)
    // =========================================================================

    // Buscar la opción seleccionada en la estructura del menú
    const opcionSeleccionada = menuUsuario
        .flatMap(grupo => grupo.opciones || [])
        .find(sub => sub.codigo === codigo);

        // Actualizar la opción activa y el estado de la estrella
        opcionActiva = opcionSeleccionada;
        actualizarEstadoEstrella();
        actualizarMenuContextual();

    if (!opcionSeleccionada) {
        console.error(`Error: Elemento "${codigo}" no localizado en la estructura del árbol.`);
        return;
    }

    const nombreFuncion = opcionSeleccionada.componente;
    const renderizarPagina = VISTAS[nombreFuncion];

    if (typeof renderizarPagina === 'function') {
        content.innerHTML = renderizarPagina();
    } else {
        console.error(`❌ Error Interno: "${nombreFuncion}" no está exportada o escrita correctamente.`);
        content.innerHTML = `
            <div class="alert alert-warning m-3" role="alert">
                <h5>Módulo no disponible</h5>
                <p class="mb-0">El componente asociado a este menú no se encuentra registrado en el frontend.</p>
            </div>
        `;
    }
}

// ============================================
// FUNCIONES DE CARGA Y RENDERIZADO DE CASA
// ============================================
async function mostrarCasa() {

    // Quitar opción activa del menú
    document
        .querySelectorAll('.sidebar__item.active')
        .forEach(item => {
            item.classList.remove('active');
        });

    // Ya no hay módulo activo
    opcionActiva = null;

    // Actualizar estrella
    actualizarEstadoEstrella();

    // Título principal
    updateHeaderTitle('Bienvenido');
    
    // Actualizar menú contextual
    actualizarMenuContextual();

    // Restaurar contenedor de la Casa
    content.innerHTML = `
        <div
            id="casa-container"
            class="casa-container">
        </div>
    `;

    // Como acabamos de recrear el elemento,
    // necesitamos recuperar su referencia
    casaContainer =
        document.getElementById('casa-container');

    casaContainer.addEventListener(
      'click',
      manejarClickCasa
    );

    // Volver a cargar la Casa desde DB
    await cargarCasa();
}

// event listener para el botón de Home en el header
if (btnHome) {

    btnHome.addEventListener(
        'click',
        mostrarCasa
    );

}

// ============================================
// FUNCIONES DE FAVORITOS
// ============================================
// Actualiza el estado visual del botón de favorito en el header
function actualizarEstadoEstrella() {

  if (!btnHeaderFavorite) return;

  if (!opcionActiva) {
    btnHeaderFavorite.disabled = true;
    btnHeaderFavorite.innerHTML =
      '<i class="far fa-star"></i>';
    btnHeaderFavorite.title =
      'No hay aplicación seleccionada';
    return;
  }

  btnHeaderFavorite.disabled = false;

  const esFavorito =
    favoritosUsuario.includes(
      opcionActiva.codigo
    );

  btnHeaderFavorite.innerHTML =
    esFavorito
      ? '<i class="fas fa-star"></i>'
      : '<i class="far fa-star"></i>';

  btnHeaderFavorite.title =
    esFavorito
      ? 'Quitar de favoritos'
      : 'Agregar a favoritos';
}

// Carga los favoritos del usuario desde la API
async function cargarFavoritosUsuario() {
  const token =
    sessionStorage.getItem('token_teresita');
  try {
    const respuesta = await fetch(
      `${URL_BASE_API}/api/preferencias/menu/favoritos`,
      {
        method: 'GET',
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      }
    );
    if (!respuesta.ok) {
      throw new Error(
        `Error al cargar favoritos: ${respuesta.status}`
      );
    }
    const resultado =
      await respuesta.json();
    if (
      resultado.success &&
      resultado.existe &&
      resultado.valor
    ) {
      favoritosUsuario =
        Array.isArray(resultado.valor.codigos)
          ? resultado.valor.codigos
          : [];
    } else {
      favoritosUsuario = [];
    }
    actualizarEstadoEstrella();
    renderizarFavoritos();
  } catch (error) {
    console.error(
      'Error al cargar favoritos:',
      error
    );
    favoritosUsuario = [];
  }
}

// Guarda los favoritos del usuario en la API
async function guardarFavoritosUsuario() {
  const token =
    sessionStorage.getItem('token_teresita');

  const respuesta = await fetch(
    `${URL_BASE_API}/api/preferencias/menu/favoritos`,
    {
      method: 'PUT',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      },

      body: JSON.stringify({
        valor: {
          codigos: favoritosUsuario
        }
      })
    }
  );

  if (!respuesta.ok) {
    throw new Error(
      `Error al guardar favoritos: ${respuesta.status}`
    );
  }
}

// Alterna el estado de favorito de la opción actualmente activa
async function alternarFavoritoActual() {
  if (!opcionActiva) return;
  const codigo =
    opcionActiva.codigo;
  const indice =
    favoritosUsuario.indexOf(codigo);
  if (indice >= 0) {
    favoritosUsuario.splice(indice,1);
  } else {
    favoritosUsuario.push(codigo);
  }
  actualizarEstadoEstrella();
  renderizarFavoritos();
  try {
    await guardarFavoritosUsuario();
  } catch (error) {
    console.error(
      'Error al actualizar favorito:',
      error
    );
  }
}

// Renderiza la lista de favoritos del usuario en el menú lateral
function renderizarFavoritos() {
  if (!menuFavoritos) return;
  menuFavoritos.innerHTML = '';
  if (!favoritosUsuario.length) {
    return;
  }
  const opcionesPermitidas =
    menuUsuario.flatMap(
      grupo => grupo.opciones || []
    );
  const favoritosValidos =
    favoritosUsuario
      .map(codigo =>
        opcionesPermitidas.find(
          opcion => opcion.codigo === codigo
        )
      )
      .filter(Boolean);

  menuFavoritos.innerHTML =
    favoritosValidos.map(opcion => `
      <li
        class="sidebar__item sidebar__item--favorito"
        data-title="${opcion.nombre}">
        <a
          href="${opcion.ruta || '#'}"
          data-codigo="${opcion.codigo}"
          data-favorito="true">
          <i class="fas ${opcion.icono}"></i>
          <span>
            ${opcion.nombre}
          </span>
        </a>
      </li>
    `).join('');
}

// ============================================
// FUNCIONES DE SIDEBAR
// ============================================
function configurarEventosSidebar() {
  if (btnLogout) {
    btnLogout.addEventListener('click', (e) => {
      e.preventDefault();
      sessionStorage.removeItem('isAuthenticated');
      sessionStorage.removeItem('token_teresita');
      localStorage.removeItem('isAuthenticated');
      window.location.replace('login.html');
    });
  }
}

// ============================================
// COMPORTAMIENTO VISUAL DEL SIDEBAR
// ============================================
// Alterna la visibilidad del sidebar según el tamaño de la ventana y el estado actual
function toggleSidebar() {
  
  const isMobile =
    window.innerWidth <= 768;
  if (isMobile) {
    if (sidebar) {
      sidebar.classList.toggle('mobile-open');
    }
    if (sidebarOverlay) {
      sidebarOverlay.classList.toggle('active');
    }
    actualizarEstadoSidebar();
    return;
  }

  const oculto =
    app?.classList.contains('sidebar-hidden');
  if (oculto) {
    mostrarSidebar();
  } else {
    ocultarSidebar();
  }
}

// Restaurar el estado del sidebar según la preferencia guardada en localStorage
function restaurarEstadoSidebar() {
  if (!app) return;
  const isMobile =
    window.innerWidth <= 768;

  /*
   * En móvil no restauramos oculto/visible.
   * Siempre inicia cerrado y funciona como overlay.
   */
  if (isMobile) {
    app.classList.remove('sidebar-hidden');
    actualizarEstadoSidebar();
    return;
  }

  const sidebarOculto =
    localStorage.getItem('sidebarOculto') === 'true';
  app.classList.toggle(
    'sidebar-hidden',
    sidebarOculto
  );
  actualizarEstadoSidebar();
}

// Cierra el sidebar en dispositivos móviles y remueve la superposición
function closeMobileSidebar() {
  if (sidebar) {
    sidebar.classList.remove('mobile-open');
  }

  if (sidebarOverlay) {
    sidebarOverlay.classList.remove('active');
  }
  actualizarEstadoSidebar();
}

// Actualiza el título del header según la opción seleccionada
function updateHeaderTitle(title) {
  if (headerTitle) headerTitle.textContent = title;
}

// Marca un elemento del sidebar como activo y actualiza el título del header
function setActiveItem(item) {
  document.querySelectorAll('.sidebar__item').forEach(el => {
    el.classList.remove('active');
  });
  if (item) {
    item.classList.add('active');
    const title = item.getAttribute('data-title');
    if (title) updateHeaderTitle(title);
  }
}

// Alterna la visibilidad de un submenú en el sidebar
function toggleSubmenu(item) {
  if (!item) return;
  const isOpen = item.classList.contains('open');
  document.querySelectorAll('.sidebar__item.open').forEach(el => {
    if (el !== item) el.classList.remove('open');
  });
  item.classList.toggle('open', !isOpen);
}

// Inicializa el comportamiento responsivo del sidebar según el tamaño de la ventana
function initResponsive() {
  const isMobile =
    window.innerWidth <= 768;
  if (isMobile) {
    closeMobileSidebar();
    if (app) {
      app.classList.remove('sidebar-hidden');
    }
  }
  actualizarEstadoSidebar();
}

// ============================================
// INICIALIZACIÓN DEL SISTEMA
// ============================================
document.addEventListener('DOMContentLoaded', async () => {
  await cargarMenuUsuario();
  await cargarFavoritosUsuario();
  await cargarCasa();
  updateHeaderTitle('Bienvenido');
  actualizarMenuContextual();
  if (btnHideSidebar) {
    btnHideSidebar.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      ocultarSidebar();
    });
  }
  if (btnShowSidebar) {
    btnShowSidebar.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      mostrarSidebar();
    });
  }
  if (sidebarOverlay) {
    sidebarOverlay.addEventListener(
      'click',
      closeMobileSidebar
    );
  }

  restaurarEstadoSidebar();
  initResponsive();

  if (btnHeaderMore && headerMoreMenu) {
  btnHeaderMore.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    headerMoreMenu.classList.toggle('open');
  });
  document.addEventListener('click', (e) => {
    if (
      !headerMoreMenu.contains(e.target) &&
      !btnHeaderMore.contains(e.target)
    ) {
      headerMoreMenu.classList.remove('open');
    }
  });
}

if (btnHeaderSeleccionar) {
  btnHeaderSeleccionar.addEventListener(
    'click',
    () => {
      if (
        opcionActiva?.componente !==
        'paginaContabilidad'
      ) {
        return;
      }

      document.dispatchEvent(
        new CustomEvent(
          'contabilidad:seleccionar'
        )
      );

      headerMoreMenu?.classList.remove('open');
    }
  );
}

if (btnHeaderExportar) {
  btnHeaderExportar.addEventListener(
    'click',
    () => {
      if (
        opcionActiva?.componente !==
        'paginaContabilidad'
      ) {
        return;
      }

      console.log('Exportar Contabilidad');
      headerMoreMenu?.classList.remove('open');
    }
  );
}

if (btnHeaderMostrar) {

    btnHeaderMostrar.addEventListener(
        'click',
        () => {

            if (
                opcionActiva?.componente !==
                'paginaContabilidad'
            ) {
                return;
            }


            document.dispatchEvent(
                new CustomEvent(
                    'contabilidad:mostrar'
                )
            );


            headerMoreMenu?.classList.remove(
                'open'
            );

        }
    );

}

// Agrega un listener al botón de favoritos en el header
if (btnHeaderFavorite) {
  btnHeaderFavorite.addEventListener(
    'click',
    async (e) => {
      e.preventDefault();
      await alternarFavoritoActual();
    }
  );
}

// Agrega un listener al menú de favoritos en el sidebar
if (menuFavoritos) {
  menuFavoritos.addEventListener(
    'click',
    manejarClickMenu
  );
}
});

// ============================================
// DELEGACIÓN DE EVENTOS - DETALLES INTERNOS DE TABLAS
// ============================================
if (content) {
  content.addEventListener('click', (event) => {
  
    // 1. DETALLE ESTILO
    if (event.target.classList.contains('detalle-estilo')) {
      event.preventDefault();
      const estiloId = event.target.getAttribute('data-id');
      content.innerHTML = paginaestiloCtesTab(estiloId);
      configurarModalColores();
    }
    
    // 2. DETALLE CLIENTE
    if (event.target.classList.contains('detalle-cliente')) {
      event.preventDefault();
      const clienteId = event.target.getAttribute('data-id');
      content.innerHTML = paginaclientePartsTab(clienteId);
      configurarModalEstilos();
    }
    
    // 3. DETALLE ARTÍCULO
    if (event.target.classList.contains('detalle-articulo')) {
      event.preventDefault();
      const articuloId = event.target.getAttribute('data-id');
      content.innerHTML = paginaarticuloCtesTab(articuloId);
      setTimeout(() => configurarModalKpisEst(), 100);
    }
    
    // 4. EMISIÓN DE GRÁFICAS - ESTILOS
    if (event.target.id === 'btn-generar-grafica') {
      const inputInicio = document.getElementById('fecha-inicio');
      const inputFin = document.getElementById('fecha-fin');
      const seleccionadas = Array.from(document.querySelectorAll('.metrica-selector:checked')).map(el => el.value);
      
      localStorage.setItem('preferenciasGrafica', JSON.stringify({
        metricas: seleccionadas, fechaInicio: inputInicio?.value || '', fechaFin: inputFin?.value || ''
      }));
      
      const panel = document.getElementById('contenedor-seleccion-metricas');
      if (panel && window.bootstrap) {
        (bootstrap.Collapse.getInstance(panel) || new bootstrap.Collapse(panel, { toggle: false })).hide();
      }
      if (typeof generarGraficaSeleccionada === 'function') generarGraficaSeleccionada();
    }
    
    // 5. EMISIÓN DE GRÁFICAS - CLIENTES
    if (event.target.id === 'btn-gen-grafctes') {
      const inputInicio = document.getElementById('cte-fecha-inicio');
      const inputFin = document.getElementById('cte-fecha-fin');
      const seleccionadas = Array.from(document.querySelectorAll('.cte-metrica-selector:checked')).map(el => el.value);
      
      localStorage.setItem('cte-preferenciasGrafica', JSON.stringify({
        metricas: seleccionadas, fechaInicio: inputInicio?.value || '', fechaFin: inputFin?.value || ''
      }));
      
      const panel = document.getElementById('cte-cont-seleccion-metricas');
      if (panel && window.bootstrap) {
        (bootstrap.Collapse.getInstance(panel) || new bootstrap.Collapse(panel, { toggle: false })).hide();
      }
      if (typeof generarGraficaCtes === 'function') generarGraficaCtes();
    }
  });
}

window.addEventListener('load', initResponsive);
window.addEventListener('resize', initResponsive);

function guardarEstadoSidebar(oculto) {

  localStorage.setItem(
    'sidebarOculto',
    oculto ? 'true' : 'false'
  );

}

// ============================================
// FUNCIONES DE SIDEBAR
// ============================================
// Actualiza la visibilidad del botón de mostrar/ocultar sidebar según el estado actual y el tamaño de la ventana
function actualizarEstadoSidebar() {
  const isMobile =
    window.innerWidth <= 768;
  if (btnShowSidebar) {
    if (isMobile) {
      const menuAbierto =
        sidebar?.classList.contains('mobile-open');
      btnShowSidebar.style.display =
        menuAbierto ? 'none' : 'flex';
    } else {
      const oculto =
        app?.classList.contains('sidebar-hidden');
      btnShowSidebar.style.display =
        oculto ? 'flex' : 'none';
    }
  }
}

// Oculta el sidebar y guarda el estado en localStorage
function ocultarSidebar() {
  const isMobile =
    window.innerWidth <= 768;
  if (isMobile) {
    closeMobileSidebar();
    return;
  }
  if (!app) return;
  app.classList.add('sidebar-hidden');
  guardarEstadoSidebar(true);
  actualizarEstadoSidebar();
}

// Muestra el sidebar y guarda el estado en localStorage
function mostrarSidebar() {
  const isMobile =
    window.innerWidth <= 768;
  if (isMobile) {
    if (sidebar) {
      sidebar.classList.add('mobile-open');
    }
    if (sidebarOverlay) {
      sidebarOverlay.classList.add('active');
    }
    actualizarEstadoSidebar();
    return;
  }
  if (!app) return;
  app.classList.remove('sidebar-hidden');
  guardarEstadoSidebar(false);
  actualizarEstadoSidebar();
}

// ============================================
// FUNCIONES DE CARGA Y RENDERIZADO DE CASA
// ============================================
async function cargarCasa() {
    if (!casaContainer) return;
    const token =
        sessionStorage.getItem('token_teresita');
    try {
        const respuesta = await fetch(
            `${URL_BASE_API}/api/casa`,
            {
                method: 'GET',
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json'
                }
            }
        );
        if (!respuesta.ok) {
            throw new Error(
                `Error al cargar Casa: ${respuesta.status}`
            );
        }
        const resultado =
            await respuesta.json();
        if (
            !resultado.success ||            
            !Array.isArray(resultado.elementos)
        ) {
            casaContainer.innerHTML = '';
            return;
        }
        renderizarCasa(
            resultado.elementos
        );
    } catch (error) {
        console.error(
            'Error al cargar Casa:',
            error
        );
        casaContainer.innerHTML = `
            <div class="casa__error">
                No fue posible cargar las aplicaciones.
            </div>
        `;
    }
}

// FUNCIONES DE RENDERIZADO DE CASA
function renderizarCasa(elementos) {

    if (!casaContainer) return;

    if (!elementos.length) {

        casaContainer.innerHTML = `
            <div class="casa__vacia">
                No hay aplicaciones disponibles.
            </div>
        `;

        return;
    }

    const techo =
        elementos
            .filter(
                elemento =>
                    elemento.posicion === 'techo'
            )
            .sort(
                (a, b) =>
                    a.orden - b.orden
            );

    const pared =
        elementos
            .filter(
                elemento =>
                    elemento.posicion === 'pared'
            )
            .sort(
                (a, b) =>
                    a.orden - b.orden
            );


    casaContainer.innerHTML = `

        <div class="casa">

            <div class="casa__titulo">
                Información para una mejor toma de decisiones
            </div>


            <!-- PIRÁMIDE DECORATIVA -->

            <div class="casa__piramide"></div>


            <!-- OPCIONES DEL TECHO -->

            <div class="casa__techo">

                ${techo.map((elemento) => `
                    
                    <button
                        type="button"
                        class="casa__elemento casa__elemento--techo"
                        style="background-color: ${elemento.color || '#299cad'};"                        
                        data-id-elemento="${elemento.id_elemento}"
                        data-tipo="${elemento.tipo_destino}"
                        data-codigo="${elemento.codigo || ''}"
                        data-url="${elemento.url_externa || ''}"
                        data-nueva-ventana="${elemento.abrir_nueva_ventana}"
                    >

                        <span>
                            ${elemento.nombre}
                        </span>

                    </button>

                `).join('')}

            </div>


            <!-- PAREDES -->

            <div class="casa__pared">

                ${pared.map(elemento => `
                    
                    <button
                        type="button"
                        class="casa__elemento casa__elemento--pared"
                        style="background-color: ${elemento.color || '#d9e8f7'};"
                        data-id-elemento="${elemento.id_elemento}"
                        data-tipo="${elemento.tipo_destino}"
                        data-codigo="${elemento.codigo || ''}"
                        data-url="${elemento.url_externa || ''}"
                        data-nueva-ventana="${elemento.abrir_nueva_ventana}"
                    >

                        <span>
                            ${elemento.nombre}
                        </span>

                        <i class="fas fa-chevron-right"></i>

                    </button>

                `).join('')}

            </div>


            <div class="casa__instruccion">
                Seleccione el área que desea consultar
            </div>

        </div>
    `;
}

// FUNCIONES DE MANEJO DE EVENTOS DE CASA
casaContainer?.addEventListener(
    'click',
    manejarClickCasa
);
// Maneja el click en un elemento de la casa, determinando si es interno o externo
function manejarClickCasa(event) {
    const elemento =
        event.target.closest(
            '.casa__elemento'
        );
    if (!elemento) return;
    const tipo =
        elemento.dataset.tipo;
    if (tipo === 'externo') {
        const url =
            elemento.dataset.url;
        const nuevaVentana =
            elemento.dataset.nuevaVentana === 'true';
        if (!url) return;
        if (nuevaVentana) {
            window.open(
                url,
                '_blank',
                'noopener,noreferrer'
            );
        } else {
            window.location.href =
                url;
        }
        return;
    }
    if (tipo === 'interno') {
        const codigo =
            elemento.dataset.codigo;
        abrirAplicacionDesdeCasa(
            codigo
        );
    }
}
// Abre una aplicación interna desde la casa, buscando la opción correspondiente en el menú
function abrirAplicacionDesdeCasa(codigo) {
    const opcionSeleccionada =
        menuUsuario
            .flatMap(
                grupo => grupo.opciones || []
            )
            .find(
                opcion =>
                    opcion.codigo === codigo
            );
    if (!opcionSeleccionada) {
        console.warn(
            'La aplicación no está disponible:',
            codigo
        );
        return;
    }
    const nombreFuncion =
        opcionSeleccionada.componente;
    const renderizarPagina =
        VISTAS[nombreFuncion];
    if (
        typeof renderizarPagina !== 'function'
    ) {
        console.error(
            'No existe el componente:',
            nombreFuncion
        );
        return;
    }
    opcionActiva =
        opcionSeleccionada;
    actualizarEstadoEstrella();
    actualizarMenuContextual();
    updateHeaderTitle(
        opcionSeleccionada.nombre
    );
    content.innerHTML =
        renderizarPagina();
}

// ============================================
// FUNCIONES DE ACTUALIZACIÓN DE MENÚ CONTEXTUAL
// ============================================
function actualizarMenuContextual() {

    const opcionesContabilidad =
        document.querySelectorAll(
            '.header-more-contabilidad'
        );

    const esContabilidad =
        opcionActiva?.componente ===
        'paginaContabilidad';


    opcionesContabilidad.forEach(
        opcion => {

            opcion.style.display =
                esContabilidad
                    ? 'block'
                    : 'none';

        }
    );

}
